<template>
    <div class="sf-carousel">
        <div class="sf-carousel__wrapper">
            <div ref="glide" class="glide">
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides sf-carousel__slides">
                        <slot />
                    </ul>
                </div>
                <div
                    class="glide__dots"
                    v-if="count"
                    data-glide-el="controls[nav]"
                >
                    <button
                        class="glide__dots__dot"
                        v-for="item in count"
                        :class="{ 'active-dot': item == active }"
                        :data-glide-dir="`=${item - 1}`"
                    >
                        <span class="glide__dots__dot__text">{{ item }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SfCarouselItem from "@storefront-ui/vue/components/organisms/SfCarousel/_internal/SfCarouselItem.vue";
import Glide from "@glidejs/glide";
Vue.component("SfCarouselItem", SfCarouselItem);
export default {
    name: "AgCarousel",
    props: {
        settings: {
            type: Object,
            default: () => ({}),
        },
        count: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            glide: null,
            defaultSettings: {
                type: "slider",
                rewind: false,
                perView: 4,
                gap: 0,
                bound: false,
                breakpoints: {
                    1023: {
                        perView: 2,
                        peek: {
                            before: 0,
                            after: 50,
                        },
                    },
                },
            },
            active: 1,
        };
    },
    computed: {
        mergedOptions() {
            let breakpoints = { ...this.defaultSettings.breakpoints };
            if (this.settings.breakpoints) {
                breakpoints = { ...breakpoints, ...this.settings.breakpoints };
            }
            return {
                ...this.defaultSettings,
                ...this.settings,
                breakpoints: breakpoints,
            };
        },
    },
    mounted: function () {
        this.$nextTick(() => {
            if (!this.$slots.default) return;
            const glide = new Glide(this.$refs.glide, this.mergedOptions);
            glide.mount();
        });
    },
};
</script>
<style lang="scss">
@import "@storefront-ui/shared/styles/components/organisms/SfCarousel.scss";
</style>
